<template>
    <transition :name="transitionName">
        <div class="sui-swiper-image"
            v-if="show">
            <sui-swiper
                :list="images"
                :infinite="infinite"
                :key-name="keyName"
                :index="index"
                @change="changeSwiper">
                <template #default="{ item }">
                    <sui-image
                        loading
                        background-size="contain"
                        :src="item[keyName]"
                        @click.native="clickEvent(item)"></sui-image>
                </template>
            </sui-swiper>
            <div class="sui--index">{{ currentIndex }}/{{ images.length }}</div>
        </div>
    </transition>
</template>

<script>
import SuiImage from '../image/image'
import SuiSwiper from './index'

export default {
    name: 'sui-swiper-image',

    components: {
        SuiImage,
        SuiSwiper,
    },

    data() {
        return {
            show: false,
            images: [],
            keyName: '',
            infinite: false,
            index: 0,
            transitionName: 'sui-animation--fade-fast',
        }
    },

    computed: {
        currentIndex() {
            return this.index + 1
        }
    },

    watch: {
        'show': function (nv) {
            if (nv) {
                history.pushState({}, '', '')
                window.addEventListener('popstate', this.popstateEvent)
            } else {
                window.removeEventListener('popstate', this.popstateEvent)
            }
        }
    },

    methods: {

        /**
         * 顺序变化
         * @param {Number} index - 最新的索引
         */
        changeSwiper(index) {
            this.index = index
        },

        /**
         * 点击事件
         * @param {Object} item - 轮播项对象
         */
        clickEvent(item) {
            history.back()
        },

        /**
         * 历史记录栈弹出事件处理函数
         */
        popstateEvent() {
            this.show = false
        }
    }
}
</script>

<style lang="postcss">
.sui-swiper-image {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
    width: 100%;
    height: 100%;
    background: #000;
    > .sui--index {
        position: absolute;
        top: 4%;
        left: 5%;
        z-index: 1;
        color: #fff;
        @media (orientation: portrait) {
            font-size: 4.267vw;
        }
        @media (orientation: landscape) {
            font-size: 2.399vw;
        }
    }
}
</style>